<template>
 <section>
   <b-row>
      <b-col>
        <div class="d-flex justify-content-end mb-2">
          <b-button
            size="sm"
            variant="primary"
            :disabled="!selectedRowItemId"
            @click="onEmailMemo">
          Email</b-button>
        </div>
      </b-col>
    </b-row>
   <grid-component
      :itemData="itemData"
      :fields="fields"
      :handleRowClick="handleRowClick"
   />
   <send-emails :sendEmailData="sendEmailData" modalId="credit-memo-email"></send-emails>
   <!-- <fast-report-viewer ref="credit-memo-print" :moduleName="'CreditMemo'" :modalId="'credit-memo-print'" :parameter="selectedRowItemId" /> -->
 </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import {GRID_ID, REPORTS_CONSTANTS} from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import FastReportViewer from '@/shared/components/FastReportViewer';
import SendEmails from '@/shared/components/SendEmails/index';

import fields from './fields';

export default {
  name: 'CreditMemosTab',
  components: {
    GridComponent,
    FastReportViewer,
    SendEmails
  },
  props: {
    rmaId: [Number, String],
    contactEmail: {
      type: String,
      default: ""
    },
    vendorRmaId: [Number, String]
  },
  data: () => ({
    fields,
    gridId: GRID_ID.CREDIT_MEMOS_TAB_GRID,
    selectedRowItemId: 0,
    sendEmailData: {}
  }),
  watch: {
    rmaId() {
      this.getCreditMemos();
    },
    vendorRmaId() {
      this.getCreditMemos();
    }
  },
  computed: {
    ...mapGetters('creditMemos', ['creditMemoByReference']),

    itemData() {
      return this.creditMemoByReference.map(memo => ({ ...memo, selected: memo.id == this.selectedRowItemId}));;
    },
    reportOption() {
      return REPORTS_CONSTANTS.filter(x => x.module == 'CreditMemo');
    }
  },
  methods: {
    ...mapActions('creditMemos', ['getCreditMemoByReference']),
    ...mapMutations('creditMemos', ['setItem']),
    async getCreditMemos() {
      let refStr = null;
      if (this.rmaId > 0) {
        refStr = `{rmaId: ${this.rmaId}}`
      } else if (this.vendorRmaId > 0) {
        refStr = `{vendorRmaId: ${this.vendorRmaId}}`
      }


      if (refStr != null) {
        await this.getCreditMemoByReference(refStr);
      } else {
        this.setItem({resource: 'creditMemoByReference', payload: []});
      }
    },
    handleRowClick({ dataItem }) {
      this.selectedRowItemId = dataItem.id;
      this.$emit('selectedCreditMemo', dataItem.id);
    },
    onEmailMemo() {
      this.sendEmailData = {
        to:this.contactEmail,
        ReferenceId:this.selectedRowItemId,
        source: 'Credit Memo',
        reportSelectionOptions: this.reportOption
      }
      this.$root.$emit('bv::show::modal', 'credit-memo-email');
    }
  },
  mounted() {
    // this.getCreditMemos();
  },
};
</script>

<style lang="scss">
.inventory--alternative-tab {
  .alternative-grid-header {
    margin-bottom: 5px;
  }
}
</style>
